module.exports = __webpack_public_path__ + "img/1-md.9c4cf7ba.jpg";